//
export default [
    {
        field       : 'id',
        type        : 'text',
        value       : '',
        vuetifyProps: {
            label   : 'N° de registro',
        },
    },
    {
        field       : 'customer',
        type        : 'text',
        value       : '',
        vuetifyProps: {
            label   : 'Cliente',
        },
    },
    {
        field       : 'user',
        type        : 'text',
        value       : '',
        vuetifyProps: {
            label   : 'Responsable',
        },
    },
    {
        field       : 'branch_office',
        type        : 'text',
        value       : '',
        vuetifyProps: {
            label   : 'Sucursal',
        },
    },
]
